<template>
    <div id="scopes-container" class="hide">
        <div class="inner-container">
            <div class="nav-container">
                <ScopesSelector />
                <HistogramSelector />

                <svg id="btn-close-scopes" height="24" viewBox="0 0 24 24" width="24"
                     xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
                    />
                    <path d="M0 0h24v24H0z" fill="none" />
                </svg>
            </div>

            <canvas v-show="activeScopeType.value == 'parade'" id="scope-parade-canvas"></canvas>
            <canvas v-show="activeScopeType.value == 'waveform'" id="scope-waveform-canvas"></canvas>
            <div v-show="activeScopeType.value == 'vectorscope'" class="canvas-container --vectorscope">
                <canvas id="scope-vectorscope-canvas"></canvas>
            </div>
            <canvas v-show="activeScopeType.value == 'histogram'" id="histogram-canvas" height="276" width="920" ></canvas>
        </div>
    </div>
</template>

<script>
import ScopesSelector from "@/components/app/scopes/ScopesSelector";
import HistogramSelector from "@/components/app/scopes/HistogramSelector";
import { mapState } from "vuex";

export default {
    name: "Scopes",
    components: {
        ScopesSelector,
        HistogramSelector,
    },

    computed: {
        ...mapState("Scopes", ["activeScopeType"]),
    }

}
</script>

<style scoped>

</style>